export class InputManager {
  constructor() {
    this.keys = {};
    this.joystick = { x: 0, y: 0, active: false };
    this.specialTrigger = false;
    this.fireTrigger = false;
    this.setupKeyboard();
  }

  setupKeyboard() {
    window.addEventListener('keydown', (e) => {
      this.keys[e.key.toLowerCase()] = true;
      if (e.key.toLowerCase() === 'e') {
        this.specialTrigger = true;
      }
      if (e.key === ' ') {
        this.fireTrigger = true;
        e.preventDefault(); // Prevent page scroll
      }
    });

    window.addEventListener('keyup', (e) => {
      this.keys[e.key.toLowerCase()] = false;
    });
  }

  setupJoystick(baseElement, thumbElement) {
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let lastTapTime = 0;

    const centerX = baseElement.offsetWidth / 2;
    const centerY = baseElement.offsetHeight / 2;
    const maxDistance = baseElement.offsetWidth / 2 - 10;

    const updateJoystick = (clientX, clientY) => {
      const rect = baseElement.getBoundingClientRect();
      const dx = clientX - (rect.left + centerX);
      const dy = clientY - (rect.top + centerY);
      const distance = Math.sqrt(dx * dx + dy * dy);
      const limitedDistance = Math.min(distance, maxDistance);
      const angle = Math.atan2(dy, dx);

      this.joystick.x = (limitedDistance / maxDistance) * Math.cos(angle);
      this.joystick.y = (limitedDistance / maxDistance) * Math.sin(angle);
      this.joystick.active = true;

      const thumbX = this.joystick.x * maxDistance;
      const thumbY = this.joystick.y * maxDistance;
      thumbElement.style.transform = `translate(${thumbX}px, ${thumbY}px)`;
    };

    const resetJoystick = () => {
      this.joystick.x = 0;
      this.joystick.y = 0;
      this.joystick.active = false;
      thumbElement.style.transform = 'translate(0, 0)';
    };

    const handleStart = (e) => {
      e.preventDefault();
      isDragging = true;

      // Double-tap detection for special
      const now = Date.now();
      if (now - lastTapTime < 300) {
        this.specialTrigger = true;
      }
      lastTapTime = now;

      const touch = e.touches ? e.touches[0] : e;
      startX = touch.clientX;
      startY = touch.clientY;
      updateJoystick(touch.clientX, touch.clientY);
    };

    const handleMove = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const touch = e.touches ? e.touches[0] : e;
      updateJoystick(touch.clientX, touch.clientY);
    };

    const handleEnd = (e) => {
      e.preventDefault();
      isDragging = false;
      resetJoystick();
    };

    baseElement.addEventListener('mousedown', handleStart);
    baseElement.addEventListener('touchstart', handleStart, { passive: false });

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('touchmove', handleMove, { passive: false });

    window.addEventListener('mouseup', handleEnd);
    window.addEventListener('touchend', handleEnd, { passive: false });
  }

  getInput() {
    const input = {
      left: this.keys['arrowleft'] || this.keys['a'],
      right: this.keys['arrowright'] || this.keys['d'],
      up: this.keys['arrowup'] || this.keys['w'],
      down: this.keys['arrowdown'] || this.keys['s'],
      special: this.specialTrigger,
      fire: this.fireTrigger || this.keys[' '],
      joystick: this.joystick.active ? { x: this.joystick.x, y: this.joystick.y } : null
    };

    // Auto-fire when moving (keyboard or joystick)
    const isMoving = input.left || input.right || input.up || input.down ||
                     (input.joystick && (Math.abs(input.joystick.x) > 0.1 || Math.abs(input.joystick.y) > 0.1));
    if (isMoving) {
      input.fire = true;
    }

    // Reset triggers after reading
    if (this.specialTrigger) {
      this.specialTrigger = false;
    }
    if (this.fireTrigger) {
      this.fireTrigger = false;
    }

    return input;
  }

  reset() {
    this.keys = {};
    this.joystick = { x: 0, y: 0, active: false };
    this.specialTrigger = false;
    this.fireTrigger = false;
  }
}
